import styled from 'styled-components';

import Banner from '~/assets/banner.png';
import Univar from '~/assets/univar.png';
import novartis from '~/assets/novartis.png';
import aon from '~/assets/aon.png';
import olin from '~/assets/olin.png';
import friozem from '~/assets/friozem.png';
import emerson from '~/assets/emerson.png';
import gemelo from '~/assets/gemelo.png';
import wedigitek from '~/assets/wedigitek.png';

export const Container = styled.div`


  .banner {
    background-size: cover;
    background-image: url(${Banner});
    background-position: top center;
    background-repeat: no-repeat;
    height: 650px;
    margin-top: 143px;
    h1 {
      line-height: 50px;
      color: #e45a19;
      font-weight: bold;
      span:nth-child(1) {
        font-size: 3rem;
      }
      span:nth-child(2) {
        font-size: 2.5rem;
      }
      span:nth-child(3) {
        font-size: 4rem;
      }
    }
    p {
      color: #fff;
      font-size: 1.2rem;
      width: 65%;
      margin: 0 auto;
    }
  }
  .btn-details {
    background-color: gray;
    color: #fff !important;
  }
  .mt-negativa {
    margin-top: -45px;
    right: 0;
    width: 230px;
  }
  .hg-180 {
    height: 134px;
  }
  h2 {
    font-size: 7rem;
    font-weight: bold;
    color: #fff;
    line-height: 82px;
  }
  .img-agende {
    margin-top: -45px;
    right: 0;
    width: 230px;
    z-index: 999;
  }
  .fixed {
    position: fixed;
    bottom: 0;
  }
  .absolute {
    position: absolute;
  }
  @media (min-width: 1200px) {
    .absolute {
      bottom: -3485px;
    }
  }
  @media (min-width: 769px) and (max-width: 991px) {
    .absolute {
      bottom: -3808px;
    }
  }
  @media (min-width: 992px) and (max-width: 1199px) {
    .absolute {
      bottom: -3544px;
    }
  }
  @media (max-width: 992px) {
    .banner {
      margin-top: 97px;
      height: auto;
    }
  }
  @media (max-width: 767px) {
    h2 {
      line-height: initial;
      font-size: 3rem;
    }
    .banner {
      h2 {
        span:nth-child(1) {
          font-size: 2.5rem;
        }
        span:nth-child(2) {
          font-size: 2rem;
        }
        span:nth-child(3) {
          font-size: 3rem;
        }
      }
      p {
        font-size: 1.2rem;
        width: 90%;
      }
    }
    .hg-180 {
      text-align: center;
    }
    .img-agende {
      position: initial;
    }
  }
  @media (min-width: 769px) {
    .bottom-endereco {
      bottom: 146px;
    }
    .bottom-0 {
      bottom: 0;
    }
  }
`;
export const Comunicacao = styled.div`
  background-color: #e9e9e9;
  h3 {
    color: #fff;
    text-align: center;
    font-size: 2.2rem;
    font-weight: bold;
  }
  .font-1 {
    font-size: 1.3rem;
  }
  .font-2 {
    font-size: 1.5rem;
  }
  .font-3 {
    font-size: 2.3rem;
  }
  p {
    color: #fff;
    font-size: 1.2rem;
    text-align: center;
    width: 83%;
    margin: 0 auto;
  }
  h4 {
    font-size: 2.5rem;
    font-weight: bold;
  }
  .color-blue {
    color: #262658;
    font-weight: bold;
  }
  h4 .color-blue {
    line-height: 45px;
  }
  .color-orange {
    color: #e45a19;
    line-height: 45px;
  }
  .bg-comunicacao {
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;
    height: 350px;
    cursor: pointer;
  }
  .bg-generico {
    background: none !important;
  }
  .bg-comunicacao-2 {
    position: absolute;
  }
  .bg-1 .bg-comunicacao {
    background-image: url(${Univar});
  }
  .bg-2 .bg-comunicacao {
    background-image: url(${novartis});
  }
  .bg-3 .bg-comunicacao {
    background-image: url(${aon});
  }
  .bg-4 .bg-comunicacao {
    background-image: url(${olin});
  }
  .bg-6 .bg-comunicacao {
    background-image: url(${friozem});
  }
  .bg-7 .bg-comunicacao {
    background-image: url(${emerson});
  }
  .bg-8 .bg-comunicacao {
    background-image: url(${gemelo});
  }
  .bg-9 .bg-comunicacao {
    background-image: url(${wedigitek});
  }
  @media (min-width: 769px) and (max-width: 991px) {
    h4 {
      font-size: 2rem;
    }
  }
  @media (max-width: 767px) {
    .overflow-sm {
      overflow: auto;
    }
    .w-1440 {
      width: 3000px;
    }
    .bg-comunicacao {
      border-radius: 40px;
    }
    .visible-mobile img {
      width: 100%;
    }
  }
  @media (min-width: 768px) {
    .visible-mobile {
      display: none;
    }
  }
`;
export const Marketing = styled.div`
  span {
    color: #262658;
    font-size: 4rem;
    .text-orange {
      color: #e45a19;
    }
  }
  h2 {
    font-weight: bold;
    font-size: 4rem;
    color: #e45a19;
  }
  p {
    color: #262658;
    font-size: 1.4rem;
  }
  @media (min-width: 769px) and (max-width: 991px) {
    .paragrafo-2 {
      width: 564px;
    }
  }
  @media (max-width: 767px) {
    p {
      font-size: 1.1rem !important;
    }
    h2 {
      font-size: 2.3rem;
    }
    span {
      font-size: 3.5rem;
      span {
        font-weight: bold;
      }
    }
  }
`;
export const Servicos = styled.div`
  h3 {
    color: #262658;
    font-size: 4rem;
    font-weight: bold;
  }
  h2 {
    font-weight: bold;
    font-size: 2rem;
    color: #262658;
  }
  .servicos-saiba {
    cursor: pointer;
  }
  p {
    color: #262658;
    font-size: 1.1rem;
    width: 80%;
    margin: 0 auto;
  }
  .tenho-interesse {
    background-color: #e45a19;
    color: #fff !important;
    border-radius: 20px;
    padding: 4% 4%;
    font-size: 1.1rem;
    font-weight: bold;
    text-decoration: none !important;
    svg {
      font-size: 2rem;
    }
  }

  @media (max-width: 767px) {
    background-color: #e9e9e9;
    h2 {
      font-size: 1.7rem !important;
    }
    h3 {
      font-size: 2.4rem;
      padding-top: 2rem;
      padding-bottom: 2rem;
    }
    .overflow {
      overflow: auto;
    }
    .w-1440 {
      width: 1120px;
      height: auto;
    }
    .visible-mobile img {
      width: 100%;
    }
  }
  @media (min-width: 768px) and (max-width: 992px) {
    h2 {
      font-size: 1.7rem;
    }

    .tenho-interesse {
      font-size: 0.87rem;
      padding: 4% 2%;
    }
  }
  @media (min-width: 768px) {
    .visible-mobile {
      display: none;
    }
  }
`;